import React, { useEffect, useState } from "react";
import { Grid } from "react-feather";
import {Link} from "react-router-dom";
import Footer from "../footer";
import Header2 from "../header2/index-two";
import SubKatChard from "../sub/SubKatChard";
// import axios from "axios";
import { useLocation } from "react-router-dom";
import axiosInstance from "../../axios";
export default function Subresult() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const jenis = params.get("jenis");
  const komoditi = params.get("komoditi");

  // axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
  
  const [subkat, setSubkat] = useState([])
  const [countpar, setCountpar] = useState()
  const [countkat, setCountkat] = useState()
  useEffect(()=>{
    const getSubkat = async() =>{
      let res = await axiosInstance.post('https://bbpom-makassar.com/api/search-sub', {
        jenis: jenis,
        comodity: komoditi,
      });
      setSubkat(res.data.data)
      // setParameter(res.data.par)
      setCountkat(res.data.count)
      setCountpar(res.data.countpar)
    }

    getSubkat()
  },[jenis, komoditi])



  console.log('hasil',subkat)
  return (
    <div className="main-wrapper">
      <Header2 
        activeMenu={"List"} 
      />
     

      {/* Page Wrapper */}
      <div className="page-content">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              {/* Filter */}
              <div className="showing-list">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="d-flex align-items-center">
                      <div className="view-icons">
                        
                        <Link to="/student/students-list" className="list-view active">
                          <Grid size={19} />
                        </Link>
                      </div>
                      <div className="show-result">
                      { countkat == null ?  (<h4>No data to showing</h4>):(<h4>Showing {countkat} results, with {countpar} total parameter</h4>)
                      
                      }
                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Filter */}
              <div className="row">
              </div>
              <div className="row">
                {/* Instructor List */}
                <div className="col-lg-12">
                  <div className="student-grid-blk">
                  <div className="row">
                  {countkat != null ? (subkat.map((sub,index)=>{
                      return(
                        <SubKatChard
                        key = {index}
                        title = {sub.nm_sub_kategory}
                        id= {sub.id}
                        header={sub.uji_kategory.nm_kategory}
                        parameter={sub.transuji_count}
                        />
                      )}))
                    :
                    (<h5 style={{textAlign:'center'}}>No data found</h5>)
                  }
                  </div>
                  </div>
                </div>
                {/* Instructor List */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Page Wrapper */}
      <Footer />
    </div>
  );
}
